import { IHouseFlatCredit, HouseFlatCredit } from "./house-flat-credit.model";

export interface IMovementCreditDetail {
  totalCreditBalance: number;
  housesWithCredit: number;
  houses: IHouseFlatCredit[];
}

export class MovementCreditDetail {
  totalCreditBalance: number;
  housesWithCredit: number;
  houses: HouseFlatCredit[];

  constructor(data: IMovementCreditDetail) {
    this.totalCreditBalance = data.totalCreditBalance ?? 0;
    this.housesWithCredit = data.housesWithCredit ?? 0;
    this.houses = data.houses
      ? data.houses.map((house) => new HouseFlatCredit(house))
      : [];
  }
}
